<script>
import {
  layoutMethods
  ,billsPaymentMethods
} from "@/state/helpers";
import ImageUploader from "@/components/ImageUploader";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";
import { getModuleAccess } from '@/router/helper.js'
import activityLogs from "@/views/pages/billsPayment/billsPaymentActivityLogs.vue";

/**
 * update bills payment component
 * Modified by: John mark arquitola
 * date:        May 25 2023
 * Description: add manual Insert biller in default provider
 */
export default {
  page: {
    title: "Bills Payment",
  },
  data() {
    return {
      title: "Bills Payment",
      billerId: 0,
      folder: 'biller-images',
      billerLogo: {
        filename: null,
        type: null,
        base64: null,
      },
      biller: {
        billerId: null,
        billerImageSrc: null,
        billerName: null,
        billerStatus: null,
        // billerProvider: {},
        billerConvenienceFee: 0,
        billerServiceFee: 0,
        billerMerchantCommission: 0,
        billerPeddlrConvenienceFee: 0,
        billerPeddlrShareFee: 0,
        billerSellerCommissionFee: 0,
        billerFinalConvenienceFee: 0,
        billerCategory:null
      },
      formExitChecker: {
        billerId: null,
        billerImageSrc: null,
        billerName: null,
        billerStatus: null,
        // billerProvider: {},
        billerConvenienceFee: 0,
        billerServiceFee: 0,
        billerMerchantCommission: 0,
        billerPeddlrConvenienceFee: 0,
        billerPeddlrShareFee: 0,
        billerSellerCommissionFee: 0,
        billerFinalConvenienceFee: 0,
        billerCategory:null
      },
      formValidation: {
          img: false,
          provider: false,
          name: false,
          biller: false,
          category: false,
      },
      provider_list:[],
      isSubmitted: false,
      formStatus:'',
      billsPaymentModule: {
        access: {
          update: true
        }
      },
      isUpdateForm:false,
      biller_list:[],
      biller_list_count:0,
      category_list:[],
      isPeddlrShareValid:false,
      selectedBiller:{id:null},
      display_service_fee:false,
      addBillerListModal:false,
      addBillerModal: {
        searchField : null,
        search:null,
        provider:null,
        sort: 'biller_name',
        orderDesc: false,
        page: 1,
        rows: 10,
      },
      providerOption:[
        { text: "All", value: null }
      ],
      modalSearchList:[
        { text: "Search All", value: null },
        { text: "Biller Name", value: "biller_name" },
        { text: "Service Provider", value: "provider_name" },
      ],
      tblFields: [
        {key: 'action', label:'Action',sortable: false},
        {key: 'biller_name', sortable: true},
        {key: 'provider_name', label:'Biller Provider', sortable: true},
        {key: "service_fee",sortable: true},
        {key: "convenience_fee",label:"Supplier Convenience Fee",sortable: true},
        {key: "peddlr_conve_fee",label:"Peddlr Convenience Fee",sortable: true},
        {key: "final_conve_fee",label:"Final Convenience Fee",sortable: true},
        {key: "merchant_comm_fee",label:"Merchant Share",sortable: true},
        {key: "peddlr_share_fee",label:"Peddlr Share",sortable: true},
        {key: "seller_comm_fee",label:"Store Commission",sortable: true},
      ],
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      sortBy: "value",
      sortDesc: false,
    };
  },
  components: {
    ImageUploader,
    Multiselect,
    activityLogs
  },
  methods: {
    ...layoutMethods,
    ...billsPaymentMethods,
    async getBillers(state=null){
      if(state == 'reset'){
        this.addBillerModal.page = 1;
      }
      await this.actionBillsPayment({
          action: "biller-list",
          body: {...this.addBillerModal}
      })
      .then((res) => {
        // console.log(res);
        this.biller_list = res["message"]["rows"];
        this.biller_list_count= res["message"]["pageInfo"]["total"];
      }).catch((e)=>{
        console.log("error while getting biller list",e);
      });
    },
    async getCategory(){
      await this.actionBillsPayment({
          action: "category-list",
          body: {}
      })
      .then((res) => {
        // console.log(res);
        this.category_list = res["message"]["rows"];
      }).catch((e)=>{
        console.log("error while getting category list",e);
      });
    },
    async getProvider(){// no longer used due to changes in form
      await this.actionBillsPayment({
          action: "provider-list",
          body: {}
      })
      .then((res) => {
        // console.log(res);
        // this.provider_list = res["message"]["rows"];
        for(let r of res["message"]["rows"]){
          this.providerOption.push({text: r.provider_name, value: r.provider_code})
        }
      }).catch((e)=>{
        console.log("error while getting provider list",e);
      });
    },
    async getDetails(){
      console.log(":: HEY!!!! ::");
      await this.actionBillsPayment({
          action: "biller-details",
          body: {"id":this.billerId}
      })
      .then((res) => {
        // console.log(res);
        this.isUpdateForm = true;
        this.biller = {...res["message"]["rows"]};
        this.selectedBiller={
          id:this.biller.billerId,
          image:this.biller["billerImage"],
          biller_code:this.biller.billerCode,
          service_provider:this.biller.billerProviderCode,
          org_s3_src:this.biller["billerImage"],
          biller_name:this.biller.billerName,
        }
        console.log("this.biller",this.biller);
        this.biller.billerCategory = this.category_list.find(x => x.id === this.biller.billerCategory);
        this.display_service_fee = true;

        this.formExitChecker = {...this.biller};
      }).catch((e)=>{
        console.log("error while getting provider list",e);
      });
    },
    clearLogo() {
      this.billerLogo = {
        filename: null,
        type: null,
        base64: null,
      };
    },
    checkForm() {
      console.log("HEY!",JSON.stringify(this.biller))
      this.formValidation.img = false;
      // this.formValidation.provider = false;
      this.formValidation.name = false;
      this.formValidation.biller = false;
      this.formValidation.category = false;
      var status = true;
      // if(this.biller.billerProvider == null){
      //   status = false;
      //   this.formValidation.provider = true;
      // }
      if(this.isEmpty(this.biller.billerName)){
        status = false;
        this.formValidation.name = true;
      }
      if(this.isEmpty(this.selectedBiller)){
        status = false;
        this.formValidation.biller = true;
      }
      if(this.isEmpty(this.biller.billerCategory)){
        status = false;
        this.formValidation.category = true;
      }
      // console.log(JSON.stringify(this.billerLogo),JSON.stringify(this.biller.billerImageSrc));
      if(this.isEmpty(this.billerLogo.filename) && this.isEmpty(this.biller.billerImageSrc)){
        status = false;
        this.formValidation.img = true;
      }
      // console.log(">> biller details",this.biller,this.formValidation,this.billerLogo);
      if(status){ 
        // console.log("hey");
        this.isSubmitted = true;
        this.formStatus = "Uploading Image...";
        this.updateBiller();
      }
    },
    updateBiller() {
      var billerObj = { ...this.biller };

      if (this.billerLogo.base64) {
        var billerLogo = { ...this.billerLogo };
        billerLogo.folder = this.folder;

        this.uploadLogo(billerLogo)
          .then((imageKey) => {
            billerObj = {
              ...billerObj,
              billerImageSrc: imageKey,
            };
            console.log(">> billerObj:",JSON.stringify(billerObj));
            this.insertUpdateBiller(billerObj,imageKey);
          })
          .catch((err) => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        billerObj.billerImageSrc = billerObj.billerImage;
        this.insertUpdateBiller(billerObj);
      }
    },
    async insertUpdateBiller(billerObj,s3_src = null){
        // console.log("s3_src",s3_src);
        // console.log("this.selectedBiller",JSON.stringify(this.selectedBiller));
        // billerObj["selectedBiller"] = this.selectedBiller;
        billerObj.billerImageSrc        = s3_src == null ? this.selectedBiller["image"] : s3_src;
        billerObj.billerCode            = this.selectedBiller["biller_code"];
        billerObj.billerProviderCode    = this.selectedBiller["service_provider"];
        //if user retain the img of biller this will handle to as is the image src
        if(Object.prototype.hasOwnProperty.call(this.selectedBiller, "org_s3_src") && s3_src == null){
          billerObj.billerImageSrc = this.selectedBiller["org_s3_src"];
        }
        // console.log("JMA:",JSON.stringify(billerObj));
        await this.actionBillsPayment({
            action: "save-default-biller",
            body: {...billerObj}
        })
        .then((res) => {
          console.log("INSERT BILLER",res);
          this.biller = billerObj;
          this.formExitChecker = billerObj;
          this.clearLogo();
          Swal.fire(
            (this.billerId > 0 ?"Updated":"Created")+" Successful!",
            `${this.biller.billerName} has been ${(this.billerId > 0 ?"updated":"created")}.`,
            "success"
          );
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "Bills Payment",
            }
          );
        }).catch((e)=>{
          Swal.fire("Failed!", "Something went wront please try again.", "warning");
          console.log("error while creating biller",e);
        });//*/

        // console.log("billerObj",JSON.stringify(billerObj));
        this.isSubmitted = false;
        this.formStatus = "";
    },
    async update(billerObj) {
      this.formStatus = "Updating biller...";
      billerObj["billerMerchantCommission"] = isNaN(parseFloat(billerObj["billerMerchantCommission"])) ? 0 : billerObj["billerMerchantCommission"];
      billerObj["billerPeddlrShareFee"] = isNaN(parseFloat(billerObj["billerPeddlrShareFee"])) ? 0 : billerObj["billerPeddlrShareFee"];
      billerObj["billerSellerCommissionFee"] = isNaN(parseFloat(billerObj["billerSellerCommissionFee"])) ? 0 : billerObj["billerSellerCommissionFee"];
      billerObj["billerServiceFee"] = isNaN(parseFloat(billerObj["billerServiceFee"])) ? 0 : billerObj["billerServiceFee"];
      billerObj["billerConvenienceFee"] = isNaN(parseFloat(billerObj["billerConvenienceFee"])) ? 0 : billerObj["billerConvenienceFee"];
      billerObj["billerFinalConvenienceFee"] = isNaN(parseFloat(billerObj["billerFinalConvenienceFee"])) ? 0 : billerObj["billerFinalConvenienceFee"];
      billerObj["billerPeddlrConvenienceFee"] = isNaN(parseFloat(billerObj["billerPeddlrConvenienceFee"])) ? 0 : billerObj["billerPeddlrConvenienceFee"];
      await this.actionBillsPayment({
          action: "update",
          body: billerObj
      })
      .then((res) => {
        console.log(res);
        Swal.fire(
          "Update Successful!",
          `${billerObj.billerName} has been updated.`,
          "success"
        );
        this.formStatus = "";
        this.isSubmitted = false;
        this.biller = billerObj;
        this.formExitChecker = billerObj;
        this.clearLogo();
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "Bills Payment",
          }
        );
      }).catch((e)=>{
          Swal.fire(
            "Update Failed!",
            Object.prototype.hasOwnProperty.call(e, "message")? e.message : `${billerObj.billerName} was not updated.`,
            "error"
          );
          // this.clearLogo();
          this.formStatus = "";
          this.isSubmitted = false;
      });
    },
    leaveform(next){
        if(JSON.stringify(this.biller) == JSON.stringify(this.formExitChecker) && this.billerLogo["filename"] == null){
          next();
          return;
        }
        Swal.fire({
            title: 'Are you sure?',
            text: "you want to leave this page?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '##804997',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                next();
            }else{
                return;
            }
        })
    },
    computeFinalConveFee(){
      if(!isNaN(parseInt(this.biller.billerPeddlrConvenienceFee))){
        this.biller.billerConvenienceFee = isNaN(parseFloat(this.biller.billerConvenienceFee))? 0:this.biller.billerConvenienceFee;
        this.biller.billerFinalConvenienceFee = parseFloat(this.biller.billerPeddlrConvenienceFee) + parseFloat(this.biller.billerConvenienceFee); 
      }else{
        this.biller.billerFinalConvenienceFee = this.biller.billerConvenienceFee;
      }
    },
    computeStoreCommission(){
      this.isPeddlrShareValid = false;
      var peddlr_share = 0,
          merchant_share=0;
      if(!isNaN(parseFloat(this.biller.billerPeddlrShareFee))){
        peddlr_share = parseFloat(this.biller.billerPeddlrShareFee)
      }
      if(!isNaN(parseFloat(this.biller.billerMerchantCommission))){
        merchant_share = parseFloat(this.biller.billerMerchantCommission)
      }
      this.biller.billerSellerCommissionFee = merchant_share - peddlr_share
      if(this.biller.billerSellerCommissionFee < 0){
        this.isPeddlrShareValid = true;
        this.biller.billerSellerCommissionFee = 0
      }
    },
    billerWithProvider ({ biller_name, provider_name }) {
      return `[${provider_name}] ${biller_name}`
    },
    isEmpty(value){
        return (
        // null or undefined
        (typeof value == "undefined") || 
        (value == undefined) ||
        (value == null) ||
        (value === "") ||
        // has length and it's zero
        (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) ||
        // is an Object and has no keys
        (value.constructor === Object && Object.keys(value).length === 0)
        )
    },
    onSelectBiller(biller) {
      // console.log("onSelectBiller",JSON.stringify(biller));
      var conflict_list     = [];
      //this will check the conflict/s
      if((this.isEmpty(this.billerLogo.filename) === false || this.isEmpty(this.biller.billerImageSrc) === false)&& this.isEmpty(biller.image) === false){
        conflict_list.push("image");
      }
      if(this.isEmpty(this.biller.billerCategory) === false && this.isEmpty(biller.biller_category_id) === false){
        conflict_list.push("category");
      }
      if(this.isEmpty(this.biller.billerName) === false){
        conflict_list.push("name");
      }
      if(this.isEmpty(this.biller.billerStatus) === false){
        conflict_list.push("status");
      }
      //ask the admin if he/she want to use the biller setup
      if(conflict_list.length > 0){
        Swal.fire({
            title: 'Biller Image?',
            text: `${biller.biller_name} has existing ${conflict_list.toString()}, want to use it?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '##804997',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
              this.billerSetupConfirmation(biller);
            }
        })
      }else{
        this.billerSetupConfirmation(biller);
      }
      this.formValidation = {
          img: false,
          provider: false,
          name: false,
          biller: false,
          category: false,
      }
    },
    billerSetupConfirmation(biller){
      this.selectedBiller = biller;
      this.display_service_fee = true;
      this.biller.billerImageSrc = biller.image;
      this.clearLogo();
      this.biller.billerName    = biller.biller_name;
      this.biller.billerStatus  = biller.status;
      this.biller.billerCategory= biller.biller_category_id == null ? null : this.category_list.find(x => x.id === biller.biller_category_id);
      // this.getBillerServiceFee(biller.biller_code,biller.service_provider);
      //close modal and set fees
      this.addBillerListModal = false
      this.biller.billerConvenienceFee    = biller.convenience_fee;
      this.biller.billerServiceFee    = biller.service_fee;
      this.biller.billerMerchantCommission    = biller.merchant_comm_fee;
      this.biller.billerPeddlrConvenienceFee    = biller.peddlr_conve_fee;
      this.biller.billerPeddlrShareFee    = biller.peddlr_share_fee;
      this.biller.billerSellerCommissionFee     = biller.seller_comm_fee;
      this.biller.billerFinalConvenienceFee     = biller.final_conve_fee;
    },
    async getBillerServiceFee(biller_code,service_provider){
      await this.actionBillsPayment({
          action: "biller-service-fee",
          body: {
            biller_code : biller_code,
            service_provider: service_provider
          }
      })
      .then((res) => {
        console.log(res);
        var fees = res["message"]["rows"];
        this.biller.billerConvenienceFee = fees.convenience_fee;
        this.biller.billerServiceFee = fees.service_fee;
        this.biller.billerMerchantCommission = fees.merchant_comm_fee;
        this.biller.billerPeddlrConvenienceFee = fees.peddlr_conve_fee;
        this.biller.billerPeddlrShareFee = fees.peddlr_share_fee;
        this.biller.billerSellerCommissionFee = fees.seller_comm_fee;
        this.biller.billerFinalConvenienceFee = fees.final_conve_fee;
      }).catch((e)=>{
        console.log("error while getting biller service fee",e);
      });
    },
    async billerListModal(is_open = false){
      this.addBillerListModal = is_open;
      if(is_open){
        await this.getBillers();
      }
    },
    tableSort(ctx){//context
      this.addBillerModal.sort = ctx.sortBy;
      this.addBillerModal.orderDesc = ctx.sortDesc;
      // console.log(">> sorting",this.addBillerModal);
      console.log(">> sorting...",ctx);
      this.getBillers('reset');
    },
    removeErrorFields(t){
      switch (t) {
        case "name":
          this.formValidation.name = false;  
          break;
        case "category":
          this.formValidation.category = false;  
          break;
        default:
          break;
      }
    }

  },
  async mounted() {
    // console.log("HAA!!!!!!",this.$route.params.id);
    this.billerId = this.$route.params.id;
    this.changeTitle({
      title: (this.billerId > 0 ? "Edit" : "Add") + " Biller",
    });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: 'Bills Payment', to: { name: 'Bills Payment'} },
        { text: "Details", to: { name: "Bills Payment Form" } }
      ],
    });
    console.log(">>>>>>>>>>>>>");
    this.getProvider();
    console.log("<<<<<<<<<<>>>>>>>>>>");
    await this.getCategory();
    console.log(":: BillerID ::",this.$route.params.id);
    if(this.billerId > 0){
      console.log(":: BillerID>> ::",this.billerId);
      await this.getDetails();
    }

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Products', 'Bills Payment', 'Bills Payment')
    .then((access) => this.billsPaymentModule.access = access);
  },
  computed: {
  },
  beforeRouteLeave(to, from, next) {
      // console.log("biller::", JSON.stringify(this.biller));
      // console.log("formExitChecker::", JSON.stringify(this.formExitChecker));
      // console.log("billerLogo::", JSON.stringify(this.billerLogo));
      
      if(JSON.stringify(this.biller) != JSON.stringify(this.formExitChecker) || this.billerLogo["filename"] != null){
        this.leaveform(next);
      }else{
        next();
      }
  }
};
</script>

<template>
  <div class="">
    <ValidationObserver v-slot="{ handleSubmit, reset }">
      <b-form @submit.prevent="handleSubmit(checkForm)" @@reset.prevent="reset">
        <div class="d-flex flex-md-row flex-column mb-3">
          <div class="pe-lg-2">
            <image-uploader
              class="me-4"
              v-model="billerLogo"
              :imageSrc="biller.billerImageSrc"
              :isRequired="formValidation.img"
            />
            <div
                v-if="formValidation.img"
                style="color: #f34e4e;font-size: 87.5%;text-align: center;">
                Image is required.
            </div>

            <activity-logs :biller ="biller"/>
          </div>
          <!-- end of img upload-->
          
          
          <div class="px-lg-2">
            <div class="card">
              <div class="card-body" style="width: 620px">
                <div class="row">
                  <label v-if="!billsPaymentModule.access.update" class="form-label medium fw-bold text-danger">Note: Your access is limited. You cannot update a Biller.</label>
                  <div class="col-md-12 mb-3">
                    <div class="form-check form-switch">
                      <label class="form-check-label" for="flexSwitchCheckDefault">Active</label>
                      <input
                        class="form-check-input"
                        v-model="biller.billerStatus"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <!--end of biller status-->
                  <div class="col-md-12 mb-3" v-if="false">
                    <label class="form-label small fw-bold">Provider<span style="color: red">*</span></label>
                        <multiselect
                          v-model="biller.billerProvider"
                          :options="provider_list"
                          track-by="provider_code"
                          label="provider_name"
                          name="provider_name"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select Provider"
                          :allow-empty="true"
                          :preselect-first="false"
                          :class="{
                              'is-invalid' : formValidation.provider
                          }"
                        ></multiselect>
                        <div
                            v-if="formValidation.provider"
                            class="invalid-feedback">
                            This value is required.
                        </div>
                  </div><!--end of biller provider-->
                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">Choose Biller<span style="color: red">*</span></label>
                        <!-- <multiselect
                          v-model="selectedBiller"
                          :options="biller_list"
                          track-by="id"
                          label="biller_name"
                          name="biller_name"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select Biller"
                          :allow-empty="true"
                          :preselect-first="false"
                          :class="{
                              'is-invalid' : formValidation.biller
                          }"
                          :custom-label="billerWithProvider"
                          @select="onSelectBiller"
                          :disabled="isDisabled"
                        ></multiselect> -->
                        <b-input-group>
                          <b-input-group-append>
                            <b-button
                              variant="light"
                              type="button"
                              class="rounded-0 rounded-start px-2" 
                              style="border: 1px #ccc solid;"
                              @click="billerListModal(true)"
                            >
                            Choose Biller
                            </b-button>
                          </b-input-group-append>
                          <b-form-input
                          type="text"
                            class="form-control"
                            v-model="selectedBiller.biller_name"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                        <div
                            v-if="formValidation.biller"
                            class="invalid-feedback">
                            This value is required.
                        </div>
                  </div><!--end of biller list-->
                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">Category<span style="color: red">*</span></label>
                        <multiselect
                          v-model="biller.billerCategory"
                          :options="category_list"
                          track-by="id"
                          label="category_description"
                          name="category_description"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select Category"
                          :allow-empty="true"
                          :preselect-first="false"
                          :class="{
                              'is-invalid' : formValidation.category
                          }"
                          @input="removeErrorFields('category')"
                        ></multiselect>
                        <div
                            v-if="formValidation.category"
                            class="invalid-feedback">
                            This value is required.
                        </div>
                  </div><!--end of biller category-->
                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">Biller Name<span style="color: red">*</span></label>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Enter biller Name"
                      v-model="biller.billerName"
                      @keypress="removeErrorFields('name')"
                      :class="{
                          'is-invalid' : formValidation.name
                      }"
                    />
                      <!-- :disabled="true" -->
                    <div
                        v-if="formValidation.name"
                        class="invalid-feedback">
                        This value is required.
                    </div>
                  </div><!--end of biller name-->

                  <div class="row p-r-0">
                    <div class="border-bottom pb-3 mb-2 col-sm-12 p-r-0">
                      <label class="form-label">Service Fee</label>
                      <b-input-group>
                        <b-input-group-append>
                          <b-button
                            variant="light"
                            type="button"
                            class="rounded-0 rounded-start px-2" 
                            style="border: 1px #ccc solid;"
                          >
                          ₱
                          </b-button>
                        </b-input-group-append>
                        <b-form-input
                        type="text"
                          class="form-control"
                          v-model="biller.billerServiceFee"
                          placeholder="0.00"
                          :disabled="!display_service_fee"
                        ></b-form-input>
                      </b-input-group>
                    </div>
                    <div class="mb-3 col-sm-6 p-r-0">
                      <label class="form-label">Supplier Convenience Fee</label>
                      <b-input-group>
                        <b-input-group-append>
                          <b-button
                            variant="light"
                            type="button"
                            class="rounded-0 rounded-start px-2" 
                            style="border: 1px #ccc solid;"
                          >
                          ₱
                          </b-button>
                        </b-input-group-append>
                        <b-form-input
                        type="text"
                          class="form-control"
                          v-model="biller.billerConvenienceFee"
                          placeholder="0.00"
                          :disabled="true"
                        ></b-form-input>
                        <div>
                          <i class="uil uil-plus text-secondary bp-icon-center"></i>
                        </div>
                      </b-input-group>
                    </div>
                    <div class="mb-3 col-sm-6 p-r-0">
                      <label class="form-label">Peddlr Convenience Fee</label>
                      <b-input-group>
                        <b-input-group-append>
                          <b-button
                            variant="light"
                            type="button"
                            class="rounded-0 rounded-start px-2" 
                            style="border: 1px #ccc solid;"
                          >
                          ₱
                          </b-button>
                        </b-input-group-append>
                        <b-form-input
                        type="text"
                          class="form-control"
                          v-model="biller.billerPeddlrConvenienceFee"
                          placeholder="0.00"
                          v-on:keyup="computeFinalConveFee()"
                          :disabled="!display_service_fee"
                        ></b-form-input>
                      </b-input-group>
                    </div>
                    <div class="border-bottom pb-3 mb-2 col-sm-12 p-r-0">
                      <label class="form-label">Final Convenience Fee</label>
                      <b-input-group>
                        <b-input-group-append>
                          <b-button
                            variant="light"
                            type="button"
                            class="rounded-0 rounded-start px-2" 
                            style="border: 1px #ccc solid;"
                          >
                          ₱
                          </b-button>
                        </b-input-group-append>
                        <b-form-input
                        type="text"
                          class="form-control"
                          v-model="biller.billerFinalConvenienceFee"
                          placeholder="0.00"
                          :disabled="true"
                        ></b-form-input>
                      </b-input-group>
                      <div class="text-muted fs-10">
                        Notes: Supplier Convenience Fee + Peddlr Convenience Fee = Final Convenience Fee
                      </div>
                    </div>
                    <div class="mb-3 col-sm-6 p-r-0">
                      <label class="form-label">Merchant Share</label>
                      <b-input-group>
                        <b-input-group-append>
                          <b-button
                            variant="light"
                            type="button"
                            class="rounded-0 rounded-start px-2" 
                            style="border: 1px #ccc solid;"
                          >
                          ₱
                          </b-button>
                        </b-input-group-append>
                        <b-form-input
                        type="text"
                          class="form-control"
                          v-model="biller.billerMerchantCommission"
                          placeholder="0.00"
                          v-on:keyup="computeStoreCommission()"
                          :disabled="!display_service_fee"
                        ></b-form-input>
                        <div>
                          <i class="uil uil-minus text-secondary bp-icon-center"></i>
                        </div>
                      </b-input-group>
                    </div>
                    <div class="mb-3 col-sm-6 p-r-0">
                      <label class="form-label">Peddlr Share</label>
                      <b-input-group>
                        <b-input-group-append>
                          <b-button
                            variant="light"
                            type="button"
                            class="rounded-0 rounded-start px-2" 
                            style="border: 1px #ccc solid;"
                          >
                          ₱
                          </b-button>
                        </b-input-group-append>
                        <b-form-input
                        type="text"
                          class="form-control"
                          v-model="biller.billerPeddlrShareFee"
                          placeholder="0.00"
                          v-on:keyup="computeStoreCommission()"
                          :class="{
                              'is-invalid': isPeddlrShareValid,
                          }"
                          :disabled="!display_service_fee"
                        ></b-form-input>
                        <div v-if="isPeddlrShareValid"
                          class="text-danger">
                          <span>Merchant Share must be greater than Peddlr Share.</span>
                        </div>
                      </b-input-group>
                    </div>
                    <div class="mb-3 col-sm-12 p-r-0">
                      <label class="form-label">Store Commission</label>
                      <b-input-group>
                        <b-input-group-append>
                          <b-button
                            variant="light"
                            type="button"
                            class="rounded-0 rounded-start px-2" 
                            style="border: 1px #ccc solid;"
                          >
                          ₱
                          </b-button>
                        </b-input-group-append>
                        <b-form-input
                        type="text"
                          class="form-control"
                          v-model="biller.billerSellerCommissionFee"
                          placeholder="0.00"
                          :disabled="true"
                        ></b-form-input>
                      </b-input-group>
                      <div class="text-muted fs-10">
                        Notes: Merchant Share - Peddlr Share = Cashback
                      </div>
                    </div>
                  </div>

                  <div v-if="!isSubmitted" class="row">
                    <div class="col-md-6 mt-3">
                      <b-button :disabled="isUpdateForm ? !billsPaymentModule.access.update:!billsPaymentModule.access.create" variant="primary" class="w-sm w-100p" type="submit">{{isUpdateForm ? "Update" : "Save"}}</b-button>
                    </div>
                    <div class="col-md-6 mt-3">
                      <router-link :to="{ name: 'Bills Payment', params: {} }" class="tc-white">
                        <b-button variant="light" class="w-sm w-100p" type="button" >Cancel</b-button>
                      </router-link>
                    </div>
                  </div>
                  <div v-else>
                    <p>{{ formStatus }}</p>
                  </div>
                </div><!-- end of row-->
              </div><!-- end of card body -->
            </div>
            <!-- end of card-->
          </div>
          <!-- end of card form-->
        </div>
        <!--end of flex-->
      </b-form>
      <!-- end of the form--> 
    </ValidationObserver><!-- end of validation observer-->
    <!-- biller Selection -->
    <b-modal
      id="addBillerList"
      title="Select Biller"
      size="lg"
      centered
      hide-footer
      v-model="addBillerListModal"
    >
      <div class="row">
          <div class="col-md-12">
            <label class="form-label small fw-bold">Search: {{biller_list_count+" Record(s)"}}</label>
            <div class="row mt-3 mb-2 px-3">
              <div class="w-auto mb-2">
                <div class="d-flex mt-3 mb-3">
                  <div class="me-3">
                    <b-form-group description="Search Keyword" class=" ta-right">
                      <form class="d-flex" @submit.prevent="getBillers()">
                        <b-form-group id="input-group-3" label-for="input-3">
                          <b-form-select
                            class="form-select rounded-0 rounded-start shadow-none"
                            style="width: fit-content"
                            id="input-3"
                            v-model="addBillerModal.searchField"
                            :options="modalSearchList"
                          ></b-form-select>
                        </b-form-group>

                        <b-input-group>
                          <b-form-input
                            class="rounded-0"
                            v-model="addBillerModal.search"
                          ></b-form-input>
                          <b-input-group-append v-if="false">
                            <b-button
                              variant="primary"
                              type="submit"
                              class="rounded-0 rounded-end px-2"
                            >
                              <i class="bx bx-search bx-fw"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </form>
                    </b-form-group>
                  </div>

                  <div class="me-3 ta-right">
                    <b-form-group label-for="transaction-status" description="Filter by Provider">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:120px"
                        id="transaction-status"
                        v-model="addBillerModal.provider"
                        :options="providerOption"
                      ></b-form-select>
                    </b-form-group>
                  </div><!--filter by Provider-->

                  <div class="me-3">
                      <b-button variant="primary" type="button" @click="getBillers()" class="px-2 me-2">
                        <i class='bx bx-search bx-fw'></i>
                        Search
                      </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div><!--search form-->
          <div class="col-sm-12">
            <!-- table responsive -->
            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="biller_list"
                  :fields="tblFields"
                  responsive="sm"
                  :current-page="addBillerModal.page"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  @sort-changed="tableSort"
                >
                  <template #cell(action)="data">
                    <div class="d-flex">
                      <div class="btn-group me-2 mb-2 mb-sm-0">
                        <span class="text-primary c-pointer" v-if="data.item.is_used == 0 && selectedBiller.id != data.item.id" @click="onSelectBiller(data.item)">
                          Select 
                        </span>
                        <span class="text-primary c-pointer" v-else-if="data.item.is_used == 0 && selectedBiller.id == data.item.id">
                          Selected 
                        </span>
                        <span class="text-muted c-pointer" v-else>
                          Used
                        </span>
                      </div>
                    </div>
                  </template>
                  <template #cell(merchant_comm_fee)="data">
                    <p class="text-center">₱ {{data.item.merchant_comm_fee | toCurrency}}</p>
                  </template>
                  <template #cell(convenience_fee)="data">
                    <p class="text-center">₱ {{data.item.convenience_fee == null ? 0:data.item.convenience_fee | toCurrency}}</p>
                  </template>
                  <template #cell(service_fee)="data">
                    <p class="text-center">₱ {{data.item.service_fee | toCurrency}}</p>
                  </template>
                  <template #cell(peddlr_conve_fee)="data">
                    <p class="text-center">₱ {{data.item.peddlr_conve_fee | toCurrency}}</p>
                  </template>
                  <template #cell(final_conve_fee)="data">
                    <p class="text-center">₱ {{data.item.final_conve_fee | toCurrency}}</p>
                  </template>
                  <template #cell(peddlr_share_fee)="data">
                    <p class="text-center">₱ {{data.item.peddlr_share_fee | toCurrency}}</p>
                  </template>
                  <template #cell(seller_comm_fee)="data">
                    <p class="text-center">₱ {{data.item.seller_comm_fee | toCurrency}}</p>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="row g-0 text-center" v-if="biller_list_count == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start">
              <!-- end col -->
              <div class="col-sm-12"  v-if="biller_list_count != 0 && biller_list_count > 10">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="addBillerModal.rows"
                            :options="pageOptions"
                            @change="getBillers()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                    >
                      <!-- pagination -->
                      <b-pagination  v-if="biller_list_count != 0 && biller_list_count > 6 && biller_list_count > addBillerModal.rows"
                        class="pagination-rounded"
                        v-model="addBillerModal.page"
                        @input="getBillers"
                        :total-rows="biller_list_count"
                        :per-page="addBillerModal.rows"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
          </div><!--end of col-12-->
      </div><!--end of row-->
    </b-modal>
    <!-- end Biller Select -->
  </div>
  <!-- end of row-->
</template>
